import { render, staticRenderFns } from "./ServicePolicyPage.vue?vue&type=template&id=3afb95c3&"
import script from "./ServicePolicyPage.vue?vue&type=script&lang=js&"
export * from "./ServicePolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports